import { GbgrundbuchmeldungService, GrundbuchmeldungSearchRequestMeta } from '../../../core/gb-api';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule, NgForm } from '@angular/forms';
import { submit } from './grundbuchmeldung.functions';
import { keysToTranslate } from 'i18n/keys-to-translate';
import { TagebuchNummerComponent } from '../../../shared/widgets/tagebuch-nummer/tagebuch-nummer.component';
import { TimepointService } from '../../../core/services/timepoint.service';
import { Subscription } from 'rxjs';
import { GbAmtSearchMode } from '../../../shared/widgets/gb-amt/gbAmtSearchMode';
import { GbGemeindeSearchMode } from '../../../shared/widgets/gb-gemeinde/gbGemeindeSearchMode';
import { AbstractSearchComponent } from '../../../shared/components/abstract-component/abstract-search.component';
import { SearchStateService } from '../../../shared/services/search-state.service';
import { ContentHeaderComponent } from '../../../shared/components/content-header/content-header.component';
import { TitleComponent } from '../../../shared/components/title/title.component';
import { MetaDirective } from '../../../shared/directives/meta.directive';
import { MetaDisablerDirective } from '../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../shared/directives/meta-validator.directive';
import { CapFormRowDirective } from '../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../shared/form-control/form-control.component';
import { GrundstueckNummerComponent } from '../../../shared/widgets/grundstueck-nummer/grundstueck-nummer.component';
import { DatepickerComponent } from '../../../shared/datepicker/datepicker.component';
import { BearbeitungsstatusSelectionComponent } from './bearbeitungsstatus-selection/bearbeitungsstatus-selection.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-grundbuchmeldung-suche',
  templateUrl: './grundbuchmeldung-suche.component.html',
  styleUrls: ['./grundbuchmeldung-suche.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    ContentHeaderComponent,
    TitleComponent,
    FormsModule,
    MetaDirective,
    TagebuchNummerComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    GrundstueckNummerComponent,
    DatepickerComponent,
    BearbeitungsstatusSelectionComponent,
    TranslatePipe
  ]
})
export class GrundbuchmeldungSucheComponent extends AbstractSearchComponent implements OnInit {
  grundbuchmeldung: GrundbuchmeldungSearchRequestMeta;

  @ViewChild(TagebuchNummerComponent, { static: false })
  private tbNummer: TagebuchNummerComponent;

  @ViewChild('form', { static: false })
  form: NgForm;

  gbAmtSearchMode = GbAmtSearchMode.GRUNDBUCHMELDUNG_REGISTER_SEARCH;
  gbGemeindeSearchMode = GbGemeindeSearchMode.GRUNDBUCHMELDUNG_REGISTER_SEARCH;

  private previousSub = new Subscription();

  constructor(
    private grundbuchmeldungService: GbgrundbuchmeldungService,
    stateService: SearchStateService,
    private route: ActivatedRoute,
    private router: Router,
    private timepointService: TimepointService
  ) {
    super(stateService);
    keysToTranslate<string>([
      'suche.status',
      'breadcrumbauskunftgrundbuchmeldung',
      'meldungEingangsdatumHeading',
      'meldungAbschlussdatumHeading',
      'meldungErwerberVeraeussererHeading',
      'meldungGebaeudeHeading',
      'bearbeitetstatusHeading',
      'Alle',
      'Bearbeitet',
      'NichtBearbeitet',
      'Grundbuchgeschäft',
      'BeteiligteGrundstuecke',
      'DatumVon',
      'DatumBis',
      'NameOderFirma',
      'Vorname',
      'GebäudeVersicherungsNummer',
      'grundbuchmeldung.suche',
      'grundbuchmeldung.SucheTitel',
      'grundbuchmeldung.search.breadcrumb',
      'RegistraturText',
      'searchZuWenigSuchkriterien'
    ]);
  }

  ngOnInit() {
    this.timepointService.resetTimepoint();
    this.addSub(
      this.grundbuchmeldungService.searchTemplateGrundbuchmeldung().subscribe((template) => {
        this.grundbuchmeldung = this.copyLastRequest(template);
      })
    );
  }

  onSubmit(): void {
    this.stateService.lastRequest = this.grundbuchmeldung;
    submit(this.form, this.grundbuchmeldung, this.router, this.route);
  }

  onReset(): void {
    this.form.reset();
    if (!this.previousSub.closed) {
      this.previousSub.unsubscribe();
    }
    this.previousSub = this.grundbuchmeldungService.searchTemplateGrundbuchmeldung().subscribe((template) => {
      this.grundbuchmeldung = template;
      this.tbNummer.focus();
      this.tbNummer.onReset();
    });
    this.addSub(this.previousSub);
  }
}
